export const LOADING_TIPS: Array<string> = [
  'Tip: Dock at a Trading Post [P] to browse supplies and recover in safety.',
  'Tip: Safe Zones disable ship combat. Use them to regroup and plan routes.',
  'Tip: Keep your cargo light. Speed matters when a chase starts.',
  'Tip: Storm belts can hide you from pursuers, but they also hide hazards.',
  'Tip: Watch your pieces (₱). Repairs and ammunition add up quickly.',
  'Tip: If you are lost, open the World Map and set a destination marker.',
  'Tip: Different waters have different threats. Upgrade before pushing deeper.',
  'Tip: Distance is a cost. Plan a loop that visits multiple ports per run.',
  'Tip: A fast ship survives longer than a strong ship with no escape route.',
  'Tip: Keep a reserve for emergency repairs before you spend on upgrades.',
  'Field Note: The Grand Latitude shifts slowly year to year. Old charts lie.',
  'Field Note: Some islands use signal beacons at night. Look for straight lines of light.',
  'Field Note: Rift storms leave the sea warm for hours. Hunters follow the heat.',
  'Field Note: Salvagers mark safe channels with square buoys. Trust the grid, not instinct.',
  'Field Note: In quiet waters, you can sometimes hear distant cannons before you see sails.',
  'Field Note: Port clerks stamp manifests by region. Keep your paperwork clean.',
  'Field Note: The Navy patrols predictable routes. Smugglers do not.',
  'Field Note: If a harbor feels too empty, assume someone is watching from shore.',
  'Field Note: Old wrecks gather in repeating patterns. The sea remembers.',
  'Field Note: When trade dries up, crews turn to raiding. Travel prepared.',
];

export const getLoadingTip = (tipIndex: number): string => {
  const safeIndex: number = Number.isFinite(tipIndex) ? Math.floor(tipIndex) : 0;
  const normalizedIndex: number = ((safeIndex % LOADING_TIPS.length) + LOADING_TIPS.length) % LOADING_TIPS.length;
  return LOADING_TIPS[normalizedIndex] || 'Tip: Stay sharp out there.';
};
